import {Component, Input} from '@angular/core';
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'app-card',
  imports: [],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent {
  @Input()
  public src: string = '';

  @Input()
  public label: string = '';

  @Input()
  comingSoon: boolean = false;
}
